import { buttonLocaleDict } from './button-locale-dict';
import { calculationRequestStatusTipLocaleDict } from './calculation-request-status-tip-locale-dict';
import { diagramsLocaleDict } from './diagrams-locale-dict';
import { dynamicAuditHistoryLocaleDict } from './dynamic-audit-history-locale-dict';
import { kendoSelectDict } from './kendo-select-dict';
import { knowledgeBaseLocaleDict } from './knowledge-base-locale-dict';
import { menuLocaleDict } from './menu-locale-dict';
import { mvcTemplateText } from './mvc-template-dict';
import { routeInfoLocaleDict } from './route-info-locale-dict';
import { staticRequisiteHistoryLocaleDict } from './static-requisite-history-locale-dict';
import { ticketProjectStatusTipLocaleDict } from './ticket-project-status-tip-locale-dict';
import { toastrLocaleDict } from './toastr-locale-dict';
import { weekdaysLocaleDict } from './weekdays-locale-dict';
import { yandexMapLocaleDict } from './yandex-map-locale-dict';

export const localeDict = {
    ru: {
        welcome: 'Добро пожаловать',
        success: 'Успех',
        error: 'Ошибка',
        attention: 'Внимание!',
        menu: menuLocaleDict.ru,
        diagrams: diagramsLocaleDict.ru,
        dynamicAuditHistory: dynamicAuditHistoryLocaleDict.ru,
        staticRequisiteHistory: staticRequisiteHistoryLocaleDict.ru,
        button: buttonLocaleDict.ru,
        knowledgeBase: knowledgeBaseLocaleDict.ru,
        mvcTemplateText: mvcTemplateText.ru,
        kendoSelect: kendoSelectDict.ru,
        toastr: toastrLocaleDict.ru,
        weekdays: weekdaysLocaleDict.ru,
        ticketProjectStatusTip: ticketProjectStatusTipLocaleDict.ru,
        routeInfo: routeInfoLocaleDict.ru,
        calculationRequestStatusTip: calculationRequestStatusTipLocaleDict.ru,
        yandexMap: yandexMapLocaleDict.ru
    },
    en: {
        welcome: 'Welcome',
        success: 'Success',
        error: 'Error',
        attention: 'Attention!',
        menu: menuLocaleDict.en,
        diagrams: diagramsLocaleDict.en,
        dynamicAuditHistory: dynamicAuditHistoryLocaleDict.en,
        staticRequisiteHistory: staticRequisiteHistoryLocaleDict.en,
        button: buttonLocaleDict.en,
        knowledgeBase: knowledgeBaseLocaleDict.en,
        mvcTemplateText: mvcTemplateText.en,
        kendoSelect: kendoSelectDict.en,
        toastr: toastrLocaleDict.en,
        weekdays: weekdaysLocaleDict.en,
        ticketProjectStatusTip: ticketProjectStatusTipLocaleDict.en,
        routeInfo: routeInfoLocaleDict.en,
        calculationRequestStatusTip: calculationRequestStatusTipLocaleDict.en,
        yandexMap: yandexMapLocaleDict.en
    },
    th: {
        welcome: 'ยินดีต้อนรับ',
        success: 'สำเร็จ',
        error: 'ข้อผิดพลาด',
        attention: 'ระวัง!',
        menu: menuLocaleDict.th,
        diagrams: diagramsLocaleDict.th,
        dynamicAuditHistory: dynamicAuditHistoryLocaleDict.th,
        staticRequisiteHistory: staticRequisiteHistoryLocaleDict.th,
        button: buttonLocaleDict.th,
        knowledgeBase: knowledgeBaseLocaleDict.th,
        mvcTemplateText: mvcTemplateText.th,
        kendoSelect: kendoSelectDict.th,
        toastr: toastrLocaleDict.th,
        weekdays: weekdaysLocaleDict.th,
        ticketProjectStatusTip: ticketProjectStatusTipLocaleDict.th,
        routeInfo: routeInfoLocaleDict.th,
        calculationRequestStatusTip: calculationRequestStatusTipLocaleDict.th,
        yandexMap: yandexMapLocaleDict.th
    },
    tr: {
        welcome: 'Hoş geldiniz',
        success: 'Başarılı',
        error: 'Hata',
        attention: 'Dikkat!',
        menu: menuLocaleDict.tr,
        diagrams: diagramsLocaleDict.tr,
        dynamicAuditHistory: dynamicAuditHistoryLocaleDict.tr,
        staticRequisiteHistory: staticRequisiteHistoryLocaleDict.tr,
        button: buttonLocaleDict.tr,
        knowledgeBase: knowledgeBaseLocaleDict.tr,
        mvcTemplateText: mvcTemplateText.tr,
        kendoSelect: kendoSelectDict.tr,
        toastr: toastrLocaleDict.tr,
        weekdays: weekdaysLocaleDict.tr,
        ticketProjectStatusTip: ticketProjectStatusTipLocaleDict.tr,
        routeInfo: routeInfoLocaleDict.tr,
        calculationRequestStatusTip: calculationRequestStatusTipLocaleDict.tr,
        yandexMap: yandexMapLocaleDict.tr
    }
};
